<ng-container class="container-simpleMedia d-flex justify-content-center">
    <div class="container-simpleMedia__container-image no-print">
        <div *ngIf="block.immagine"
            class="container-simpleMedia__container-image__image-box position-relative {{ classItem }}">
            <img loading="lazy" [src]="imgPath" [alt]="block.testo_alt">
            <div *ngIf="block.descrizione"
                class="container-simpleMedia__container-image__image-box__text position-absolute"
                [innerHTML]="block.descrizione"></div>
        </div>
    </div>
    <app-sample-print [imageUrl]="imgPath" [description]="block.descrizione"></app-sample-print>
</ng-container>